/**
 * DEV-7091b — id generators (Vue 2 parity).
 *
 * `genThreadId` must produce a string of at least 33 chars — it routes the
 * Bedrock AgentCore session.
 */
let nextMsgId = 1000

export function genMsgId(): string {
  return 'msg-' + nextMsgId++
}

export function genThreadId(): string {
  const d = new Date()
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const yyyy = d.getFullYear()
  const r = () => Math.random().toString(36).slice(2)
  return `thread_id_${dd}${mm}${yyyy}_${r()}${r()}`
}
